import { Filter, FilterType } from '@dfl/mui-admin-layout';
import { emailFilter, phoneFilter } from 'modules/common/constants';
import {
  orderCodeFilter,
  orderDeliveryDueDateFilter,
  orderDistributionCenterFilter,
  orderTotalProductsFilter,
  shippingAddressFilter,
} from 'modules/sales/common/constants/order-filters';
import { addressFilters } from 'lib/dfl-address-filter/filters';

export const totalChargesFilter: Filter = {
  filter: 'stock:totalCharges',
  translate: true,
  type: FilterType.NUMBER,
  key: 'charges',
  field: 'metrics.totalCharges',
};

export const agreementsQuantityOrdersSumFilter: Filter = {
  filter: 'carriers:agreementsQuantityOrdersSum',
  translate: true,
  type: FilterType.NUMBER,
  key: 'agreementsQuantityOrdersSum',
  field: 'metrics.agreementsQuantityOrdersSum',
};

export const totalHandlingAmountFilter: Filter = {
  filter: 'conciliation:totalHandlingAmount',
  translate: true,
  type: FilterType.NUMBER,
  key: 'handling',
  field: 'metrics.totalHandlingAmount',
};

export const totalOrdersFilter: Filter = {
  filter: 'breadcrumb:orders',
  translate: true,
  type: FilterType.NUMBER,
  key: 'orders',
  field: 'metrics.orders',
};

export const amountToPayFilter: Filter = {
  filter: 'stock:amountToPay',
  translate: true,
  type: FilterType.NUMBER,
  key: 'total',
  field: 'metrics.amountToPay',
};

export const totalCostFilter: Filter = {
  filter: 'stock:amountToPay',
  translate: true,
  type: FilterType.NUMBER,
  key: 'totalCost',
  field: 'totalCost',
};

export const totalAdjustmentAmountFilter: Filter = {
  filter: 'stock:totalAdjustmentAmount',
  translate: true,
  type: FilterType.NUMBER,
  key: 'adjustment',
  field: 'metrics.totalAdjustmentAmount',
};

// Address filter for conciliation using shipping.address fields
const conciliationAddressFilter = addressFilters({
  countryFilter: 'warehouse:address.country',
  countryKey: 'country',
  countryField: 'shipping.address.country',
  stateFilter: 'warehouse:address.state',
  stateKey: 'state',
  stateField: 'shipping.address.state',
  cityFilter: 'warehouse:address.city',
  cityKey: 'city',
  cityField: 'shipping.address.city',
  justUseFor: 'CU',
});

export const totalCostDetails: Filter = {
  filter: 'common:total',
  field: 'costDetails.values.distributionCenter',
  translate: true,
  type: FilterType.NUMBER,
  key: 'total',
};

export const driverTotalFilter: Filter = {
  filter: 'stock:amountToPay',
  translate: true,
  type: FilterType.NUMBER,
  key: 'd-total',
  field: 'costDetails.values.delivery.driver',
};

export const orderWeightFilter: Filter = {
  filter: 'order:shippingPackage.weight',
  translate: true,
  type: FilterType.NUMBER,
  key: 'weight',
  field: 'costDetails.values.delivery.taxes.weight',
};

export const orderVolumeFilter: Filter = {
  filter: 'order:shippingPackage.volume',
  translate: true,
  type: FilterType.NUMBER,
  key: 'volume',
  field: 'costDetails.values.delivery.taxes.volume',
};

export const orderSpecialTransportationFilter: Filter = {
  filter: 'order:shippingPackage.specialTransportation',
  translate: true,
  type: FilterType.NUMBER,
  key: 'transportation',
  field: 'costDetails.values.delivery.taxes.specialTransportation',
};

export const carrierFilters: Filter[] = [emailFilter, phoneFilter, ...conciliationAddressFilter];

export const conciliationSuborderFilters: Filter[] = [
  orderCodeFilter,
  ...shippingAddressFilter,
  orderDistributionCenterFilter,
  orderDeliveryDueDateFilter,
  orderTotalProductsFilter,
  totalCostDetails,
];

export const driverConciliationSuborderFilters: Filter[] = [
  orderCodeFilter,
  ...shippingAddressFilter,
  orderDistributionCenterFilter,
  orderWeightFilter,
  orderVolumeFilter,
  orderSpecialTransportationFilter,
  driverTotalFilter
];
